import I18n from 'I18n';
export const i18nWithNameSpace = namespace => (key, options) => I18n.text(`${namespace}.${key}`, options);